module.exports = __webpack_public_path__ + "media/Heroimage-profile.3a976d42.mp4";